import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Typography, Row, Col, Form } from "antd";
import InDocDetail from "./includes/InDocDetail";
import InPersonnelInformation from "./includes/InPersonnelInformation";
import InDisasterHouse from "./includes/InDisasterHouse";

const { Text, Title } = Typography;

class WelfareListPaymentVictimSecDocDetail extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
  };

  async componentDidMount() {}

  render() {
    const { match, rawData, isViewOnly, form, isApproveMode } = this.props;
    const { loadingFullpage } = this.state;
    //const { getFieldDecorator } = this.props.form;

    return (
      <>
      {
        rawData &&
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2 mb-4"
        >
          <Col md={24} className="mb-3">
            <InDocDetail rawData={rawData} isViewOnly={isViewOnly} form={form}/>
          </Col>

          <Col md={24} className="mb-3">
            <InPersonnelInformation rawData={rawData} form={form}/>
          </Col>

          <Col md={24} className="mb-3">
            <InDisasterHouse rawData={rawData} isViewOnly={isViewOnly} form={form} isApproveMode={isApproveMode}/>
          </Col>
        </Row>
      }
        
      </>
    );
  }
}

WelfareListPaymentVictimSecDocDetail.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimSecDocDetail.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimSecDocDetail = Form.create()(
  WelfareListPaymentVictimSecDocDetail
);

export default withApollo(WrappedWelfareListPaymentVictimSecDocDetail);
